<template>
  <div id="contact-form">
    <Dialog
      v-if="isOpen && !isToggle"
      :open="isOpen"
      :initial-focus="completeButtonRef"
      class="relative z-[100]"
      @click="$emit('click:close-dialog')"
    >
      <!-- The backdrop, rendered as a fixed sibling to the panel container -->
      <div class="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div class="fixed inset-0 flex w-screen items-center justify-center p-2">
        <DialogPanel
          class="inline-flex flex-col w-full max-w-4xl max-h-[98vh] md:max-h-[84vh] rounded-md pb-4 bg-white overflow-hidden p-4"
        >
          <DialogTitle class="text-base font-semibold relative mb-8">
            {{ $t('product.teamEventsForm.title') }}

            <button
              type="button"
              aria-controls="drawer-right-example"
              class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute -top-2.5 end-2.5 mt-1 inline-flex items-center justify-center"
              @click.prevent="$emit('click:close-dialog')"
            >
              <svg
                class="w-3 h-3"
                aria-hidden="false"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                ></path></svg
              ><span class="sr-only">Close menu</span>
            </button>
          </DialogTitle>
          <DialogDescription class="overflow-auto">
            <div ref="hubSpotForm"></div>
            <noscript>{{ $t('product.teamEventsForm.noscript') }}</noscript>
          </DialogDescription>
        </DialogPanel>
      </div>
      <div
        :id="modalId"
        class="modal fade"
        tabindex="-1"
        aria-labelledby="teamEventModal"
        aria-hidden="true"
        data-test-id="contact-form"
      ></div>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: 'ContactForm',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    modalId: {
      type: String,
      required: true,
    },
    scriptInnerHtml: {
      type: String,
      required: false,
    },
  },

  setup(props) {
    const hubSpotForm = ref(null)

    const init = () => {
      if (hubSpotForm.value && hubSpotForm.value.innerHTML) {
        hubSportForm.value.innerHTML = ''
      }
      useScript(
        '//js-eu1.hsforms.net/forms/shell.js',
        hubSpotForm.value,
        () => {
          const scriptElement = document.createElement('script')
          scriptElement.innerHTML = props.scriptInnerHtml
            ? props.scriptInnerHtml
            : 'hbspt.forms.create({region:"eu1",portalId:"25031492",formId:"9e7effaf-fca4-4ac4-881c-06aadd2b6d6c"});'
          if (hubSpotForm.value) {
            hubSpotForm.value.appendChild(scriptElement)
          }
        }
      )
    }

    return {
      hubSpotForm,
      init,
    }
  },
}
</script>

<style lang="postcss" scoped></style>
